(function (NewsletterAccordion, $, undefined) {

  var $window = $(window),
      $document = $(document),
      $header = $('#header'),
      $main = $('#template')
      $modal = $('.newsletter-modal'),
      newMargin = $header.height();

  var optOut = function() {
    localStorage.setItem('newsletter-cro', 'true');
  }

  var bindUIActions = function () {
    KlaviyoSubscribe.attachToForms('.cro_signup', {
      hide_form_on_success: true,
      success_message: "Registration complete - thank you!",
      success: function() {
        $('.klaviyo_messages .success_message');
        setTimeout(NewsletterAccordion.hide(), 2000);
      }
    });

    $header.on('click','.newsletter-modal .vbox-close',function(){
      NewsletterAccordion.hide();
    });
  };


  NewsletterAccordion.hide = function(){
    newMargin = $header.height() - $modal.height() - 1;
    $main.animate({'marginTop': newMargin},200);
    $modal.removeClass('is-active').slideUp(200);
    optOut();
  };

  NewsletterAccordion.show = function(){
    if (!localStorage.getItem('newsletter-cro')) {
      if(IsMobile.check()) {
        $modal.appendTo($header.find('.mobile'));
      }
      $modal.show();
      newMargin = $header.height();
      $main.css({'marginTop': newMargin});
    }
  };

  NewsletterAccordion.init = function () {
    bindUIActions();
    NewsletterAccordion.show();
  };

}(window.NewsletterAccordion = window.NewsletterAccordion || {}, jQuery));
